/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Teamname1Inputs */

const zh_pricing_teamname1 = /** @type {(inputs: Pricing_Teamname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const en_pricing_teamname1 = /** @type {(inputs: Pricing_Teamname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

const es_pricing_teamname1 = /** @type {(inputs: Pricing_Teamname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max`)
};

/**
* | output |
* | --- |
* | "Max" |
*
* @param {Pricing_Teamname1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_teamname1 = /** @type {((inputs?: Pricing_Teamname1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Teamname1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_teamname1(inputs)
	if (locale === "en") return en_pricing_teamname1(inputs)
	return es_pricing_teamname1(inputs)
});
export { pricing_teamname1 as "pricing_teamName" }